import { LitElement, html, css } from "lit-element";

// language=CSS
export const InputSelectStyle = css`
	.input-select {
		position: relative;
		display: inline-block;
	}

	.input-select > select {
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		padding: 8px 0;
		outline: none;
	}

	.input-select > input-md-decorator {
		display: block;
		border-top: 1px solid #ccc;
		height: 1px;
		speak: none;
	}

	.input-select > input-md-decorator > input-underline {
		display: block;
		height: 1px;
		width: 100%;
		margin: auto;
		border-top: 1px solid #ccc;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
	}

	.input-select > input-md-decorator > input-underline {
		display: block;
		height: 2px;
		width: 100%;
		margin: auto;
		background-color: var(--app-accent, black);

		position: relative;

		top: -22px;
		left: 0;
		transform: scale3d(0, 1, 1);
		transition-property: transform, top;
		transition-duration: 0.2s;
		transition-timing-function: ease-in;
	}

	.input-select > select:focus + input-md-decorator > input-underline {
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
		top: -22px;
		transition: transform 0.2s ease-out;
	}

	.input-select > select[aria-invalid="true"]:not(:valid) + input-md-decorator > input-underline {
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
		top: -22px;
		transition: transform 0.2s ease-out;
		background-color: #ff0000;
	}

	/* input label */
	.input-select > input-md-decorator > label {
		font-size: 18px;
		display: block;
		pointer-events: none;
		opacity: 0.5;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		transition-property: opacity, -webkit-transform, font-size;
		transition-property: opacity, transform, font-size;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		-webkit-transform: translate3d(0px, -1.9em, 0px);
		transform: translate3d(0px, -1.9em, 0px);
	}

	.input-select > input-md-decorator::after {
		content: "";
		display: block;
		position: absolute;
		top: 0;
		bottom: 0;
		height: 40px;

		right: 8px;
		speak: none;
		transform: scaleY(0.6);
		color: var(--app-accent);
		pointer-events: none;
	}

	.input-select > select {
		width: 100%;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		padding: 40px 0 8px 0;
		border: none;
		background-color: transparent;
		border-radius: 0;
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		overflow: hidden;
		margin: 0;
		outline: none;
		background-repeat: no-repeat;
		background-position: 100% 35px;
		background-size: 18px;
		background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48cGF0aCBkPSJNMTYuMDAzIDE4LjYyNmw3LjA4MS03LjA4MUwyNSAxMy40NmwtOC45OTcgOC45OTgtOS4wMDMtOSAxLjkxNy0xLjkxNnoiLz48L3N2Zz4=");
	}

	.input-select > select::-ms-expand {
		display: none;
	}

	.input-select > select[aria-invalid="true"] + input-md-decorator > label,
	.input-select > select[disabled] + input-md-decorator > label,
	.input-select > select:valid + input-md-decorator > label,
	.input-select > select:focus + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	.input-select > select[aria-invalid="true"] + input-md-decorator > label {
		color: #ff0000;
	}

	.input-select > select:required + input-md-decorator > label::after {
		content: " *";
	}
`;
// language=CSS
export const InputSelectHostStyle = css`
	:host {
		position: relative;
		display: inline-block;
	}

	:host > select {
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		border: none;
		padding: 8px 0;
		outline: none;
	}

	:host > input-md-decorator {
		display: block;
		border-top: 1px solid #ccc;
		height: 1px;
		speak: none;
	}

	:host > input-md-decorator > input-underline {
		display: block;
		height: 1px;
		width: 100%;
		margin: auto;
		border-top: 1px solid #ccc;
		-webkit-transform: translateZ(0);
		transform: translateZ(0);
	}

	:host > input-md-decorator > input-underline {
		display: block;
		height: 2px;
		width: 100%;
		margin: auto;
		background-color: var(--app-accent, black);

		position: relative;

		top: -22px;
		left: 0;
		transform: scale3d(0, 1, 1);
		transition-property: transform, top;
		transition-duration: 0.2s;
		transition-timing-function: ease-in;
	}

	:host > select:focus + input-md-decorator > input-underline {
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
		top: -22px;
		transition: transform 0.2s ease-out;
	}

	:host > select[aria-invalid="true"]:not(:valid) + input-md-decorator > input-underline {
		-webkit-transform: scale3d(1, 1, 1);
		transform: scale3d(1, 1, 1);
		top: -22px;
		transition: transform 0.2s ease-out;
		background-color: #ff0000;
	}

	/* input label */
	:host > input-md-decorator > label {
		font-size: 18px;
		display: block;
		pointer-events: none;
		opacity: 0.5;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		-webkit-transform-origin: 0 0;
		transform-origin: 0 0;
		transition-property: opacity, -webkit-transform, font-size;
		transition-property: opacity, transform, font-size;
		transition-duration: 0.15s;
		transition-timing-function: ease-out;
		will-change: transform;
		-webkit-transform: translate3d(0px, -1.9em, 0px);
		transform: translate3d(0px, -1.9em, 0px);
	}

	:host > input-md-decorator::after {
		content: "";
		display: block;
		position: absolute;
		top: 0;
		bottom: 0;
		height: 40px;

		right: 8px;
		speak: none;
		transform: scaleY(0.6);
		color: var(--app-accent);
		pointer-events: none;
	}

	:host > select {
		width: 100%;
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		padding: 40px 0 8px 0;
		border: none;
		background-color: transparent;
		border-radius: 0;
		font-size: 1em;
		font-weight: 300;
		color: var(--app-primary);
		overflow: hidden;
		margin: 0;
		outline: none;
		background-repeat: no-repeat;
		background-position: 100% 35px;
		background-size: 18px;
		background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48cGF0aCBkPSJNMTYuMDAzIDE4LjYyNmw3LjA4MS03LjA4MUwyNSAxMy40NmwtOC45OTcgOC45OTgtOS4wMDMtOSAxLjkxNy0xLjkxNnoiLz48L3N2Zz4=");
	}

	:host > select::-ms-expand {
		display: none;
	}

	:host > select[aria-invalid="true"] + input-md-decorator > label,
	:host > select[disabled] + input-md-decorator > label,
	:host > select:valid + input-md-decorator > label,
	:host > select:focus + input-md-decorator > label {
		transform: translate3d(0px, -4.7em, 0px);
		font-size: 13px;
		opacity: 1;
	}

	:host > select[aria-invalid="true"] + input-md-decorator > label {
		color: #ff0000;
	}

	:host > select:required + input-md-decorator > label::after {
		content: " *";
	}
`;

export class InputSelect extends LitElement {
	static get properties() {
		return {
			name: { type: String },
			label: { type: String },
			options: { type: Array },
			selected: { type: String },
			cast: { type: String },
			required: { type: Boolean },
			disabled: { type: Boolean }
		};
	}

	static get styles() {
		return InputSelectHostStyle;
	}

	render() {
		return html`
			<select data-cast="${this.cast ? this.cast : "text"}" name="${this.name}" ?required="${this.required}" ?disabled="${this.disabled}">
				${this.options &&
					this.options.map(option => {
						return html`
							<option value="${option.name}" ?selected="${this.selected === option.name}">
								${option.label}</option
							>
						`;
					})}
			</select>
			<input-md-decorator aria-hidden="true">
				<label>${this.label}</label>
				<input-underline></input-underline>
			</input-md-decorator>
		`;
	}
}

customElements.define("input-select", InputSelect);
